// extracted by mini-css-extract-plugin
export default {"status":"styles_status__7-pXx","status_processed":"styles_status_processed__gBbfX","status_rejected":"styles_status_rejected__lUU6p"};